export const H5_URL = 'https://h5.tu.qq.com/vision/2020shengdan-shadow_ai/index.html';
export const PAGE_NAMES = {
    INDEX: 'h5_page',
    CONFIRM: 'confirm_page',
    RESULT: 'result_page',
    GUEST: 'guest_page',
};
export const MATERIAL_MAPPING = {
    skiing: {
        id: 0,
        coverIndex: 209,
    },
    fairy_tale_face: {
        id: 1,
        coverIndex: 101,
    },
    beg_gift: {
        id: 2,
        coverIndex: 144,
    },
    deer_fairy_tale_face: {
        id: 3,
        coverIndex: 144,
    },
};
export const UNDETECTED_BODY_CODE = 1003;
export const SUCCESS_CODE = 0;
export const ERROR_CODE_MAPPING = {
    [SUCCESS_CODE]: {
        msg: '获取图片成功！',
        type: 'success',
        confirmMsg: '好的',
    },
    1001: {
        msg: '未检测到用户面部，请更换照片',
        type: 'none',
        confirmMsg: '换张图片',
    },
    1005: {
        msg: '请换张图再试吧～',
        type: 'none',
        confirmMsg: '换张图片',
    },
    2114: {
        msg: '请更换图片',
        type: 'illegal',
        confirmMsg: '换张图片',
    },
    1004: {
        msg: '识别到多人，请选择其中一位',
        type: 'toomany',
        confirmMsg: '好的',
    },
    [UNDETECTED_BODY_CODE]: {
        msg: '未检测到用户人体，请更换照片',
        type: 'none',
        confirmMsg: '换张图片',
    },
    114: {
        msg: '未检测到用户面部，请更换照片',
        type: 'danger',
        confirmMsg: '换张图片',
    },
    [-110]: {
        msg: '图片处理失败, 请稍后再试吧~',
        type: 'error',
        confirmMsg: '好的',
    },
    111: {
        msg: '活动太火爆啦, 请稍后再试吧~',
        type: 'error',
        confirmMsg: '好的',
    },
};
export const DEFAULT_H5_CHRITMAS_COMMON_DATA = {
    topLottieUrl: '',
    bottomImgUrl: '',
    topTitleImgUrl: 'https://xmaterial.tu.qq.com/xeffect/material-op/material/6b91c430-3c1c-11eb-a4ee-8a9c6ac71eef-index_title.png',
    shareImgUrl: 'https://activity.tu.qq.com/web/xmas/%E7%BC%A9%E7%95%A5%E5%9B%BE.png',
};
export function generateCommonData(global) {
    if (!global.commonData)
        return DEFAULT_H5_CHRITMAS_COMMON_DATA;
    return Object.assign(Object.assign({}, DEFAULT_H5_CHRITMAS_COMMON_DATA), global.commonData.reduce((accumulator, curItem) => {
        accumulator[curItem.key] = curItem.value;
        return accumulator;
    }, {}));
}
